import React from 'react';
import RateConfig from '../../Containers/ShippingContainer/RateConfig';

const CalculationList = (props) => {
	return (
		<RateConfig {...props}/>
	);
}

export default CalculationList;